import React, { useEffect, useState } from "react";

import DashboardGreeting from "../DashboardGreeting";

import { useStateContext } from "../../contexts/ContextProvider";

import Select from "react-select";
import HelpDeskService from "../../services/helpdesk.services";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AddIcon from "../../assets/images/addIcon.svg";
import AddFeedback from "../common/AddFeedback";
import EditFeedback from "./EditFeedback";

import moment from "moment";
import Delete from "./CustomModals/Delete";
import GrievencesSortModal from "./GrievencesSortModal";
import GrievancesFilterModal from "./GrievancesFilterModal";

import { Modal, Button } from "react-bootstrap";

const HelpDesk = ({ user }) => {
  const navHeading = "Help Desk Issues";

  const [holiday, setHoliday] = useState(false);

  const [issues, setIssues] = useState([]);

  const { feedback, setFeedback, sortBy, setSortBy, filterBy, setFilterBy } =
    useStateContext();

  const initialData = {
    date: "",
    formatedDate: "Choose",
    issueType: "",
  };

  const [details, setDetails] = useState(initialData);

  const [showIssue, setShowIssue] = useState(false);

  const [editFeedback, setEditFeedback] = useState(false);

  const [deleteIssue, setDeleteIssue] = useState(false);

  // const [optionChange, setOptionChange] = useState(false);

  const [issueData, setIssueData] = useState("");

  const [filter, setFilter] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const [checkedTimeSort, setCheckedTimeSort] = useState("");
  const [status, setStatus] = useState([]);

  const [statusChecked, setStatusChecked] = useState([]);

  const [validated, setValidated] = useState(false);

  const [issueTypes, setIssueTypes] = useState([]);

  const statusOpts = [
    { value: "1", label: "New", color: "rgba(222, 248, 253, 1)" },
    { value: "2", label: "In-Process", color: "rgba(254, 210, 200, 1)" },
    { value: "3", label: "Resolved", color: "rgba(192, 241, 220, 1)" },
  ];

  const [selectedOpts, setSelectedOpts] = useState([]);
  const [selectedRow, setSelectedRow] = useState({
    id: "",
    status: "",
  });

  const [shwoAlert, setShowAlert] = useState(false);

  const handleSelectChange = (e, index, id) => {
    // setOptionChange(true);
    setSelectedOpts((prevState) => ({
      ...prevState,
      [index]: e.value,
    }));
    setShowAlert(true);
    setSelectedRow({
      id: id,
      status: e.value,
    });
  };

  const handleCloseAlert = () => setShowAlert(false);

  const fetchAllIsues = () => {
    let payload = {};
    if (user.role === "2" || user.role === "3") {
      payload = {
        empid: user.empid,
      };
    } else {
      payload = {
        id: "0",
      };
    }

    HelpDeskService.getHelpList(payload)
      .then((resp) => {
        // console.log(resp.data);
        if (user.role === "2" || user.role === "3") {
          // const empIssues = resp.data.filter(
          //   (item) => item.empid === user.empid
          // );
          setIssues(resp.data);
        } else {
          setIssues(resp.data);
        }

        // setIssues(resp.data);
        setSelectedOpts(
          Array.isArray(resp.data)
            ? resp.data.flatMap((item) => [item.status])
            : null
        );
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    fetchAllIsues();
  }, []);

  const handleUpdateStatus = () => {
    const payload = {
      id: selectedRow.id,
      status: selectedRow.status,
    };
    // console.log("payload", payload);

    HelpDeskService.updateHelpsts(payload)
      .then((resp) => {
        if (resp.data) {
          fetchAllIsues();
          toast.success("Status updated Successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            onClose: () => {
              handleCloseAlert();
            },
          });
        }
      })
      .catch((e) => console.log(e));
  };

  const removeIssue = () => {
    const data = {
      id: issueData.id,
    };

    HelpDeskService.deleteHelpIsuues(data)
      .then((resp) => {
        if (resp.data) {
          fetchAllIsues();
          toast.success("Issue Deleted Successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            onClose: () => setDeleteIssue(false),
          });
        }
      })
      .catch((e) => console.log(e));

    // console.log(data);
  };

  const applySort = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      setValidated(true);
      toast.warn("* Please fill all required fields!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    setSortBy(false);
    setFilter(true);

    if (checkedTimeSort !== "") {
      // setStatusChecked([]);
      const payload = {
        ordertype: checkedTimeSort,
      };
      HelpDeskService.sortbyTime(payload)
        .then((resp) => {
          if (resp.data) {
            if (status.length > 0) {
              if (user.role === "2" || user.role === "3") {
                const data = resp.data.filter(
                  (item) => item.empid === user.empid
                );
                const filteredData = data.filter((item) =>
                  status.includes(item.status)
                );
                setFilteredData(filteredData);
              } else {
                const filteredData = resp.data.filter((item) =>
                  status.includes(item.status)
                );
                setFilteredData(filteredData);
              }
              setSelectedOpts(
                Array.isArray(filteredData)
                  ? filteredData.flatMap((item) => [item.status])
                  : null
              );
            } else {
              if (user.role === "2" || user.role === "3") {
                const data = resp.data.filter(
                  (item) => item.empid === user.empid
                );
                setFilteredData(data);
              } else {
                setFilteredData(resp.data);
              }
             
              setSelectedOpts(
                Array.isArray(resp.data)
                  ? resp.data.flatMap((item) => [item.status])
                  : null
              );
            }
          }
        })
        .catch((e) => console.log(e));
    }

    if (status.length > 0) {
      // console.log(status);
      const filteredData = issues.filter((item) =>
        status.includes(item.status)
      );
      // console.log("filteredData", filteredData);
      setFilteredData(filteredData);
      setSelectedOpts(
        Array.isArray(filteredData)
          ? filteredData.flatMap((item) => [item.status])
          : null
      );
    }
  };

  const applyFilter = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      setValidated(true);
      toast.warn("* Please fill all required fields!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    let filteredData = issues;

    const formattedDate = moment(details.date, "YYYY-MM-DD").format(
      "DD-MM-YYYY HH:mm:ss"
    );

    const objectValues = {
      issuedate: formattedDate === "Invalid date" ? "" : formattedDate,
      helptype: details.issueType ? details.issueType.value : "",
    };

    const nonEmptyDetails = Object.fromEntries(
      Object.entries(objectValues).filter(
        ([_, value]) => value !== "" && value !== null
      )
    );

    // console.log("nonEmptyDetails", nonEmptyDetails);

    filteredData = filteredData.filter((item) =>
      Object.entries(nonEmptyDetails).every(
        ([detailsKey, value]) => item[detailsKey] === value
      )
    );

    // console.log(filteredData);

    setFilter(true);
    setFilteredData(filteredData);
  };

  const resetFilter = (e) => {
    e.preventDefault();
    setFilter(false);
    setFilterBy(false);
    setSortBy(false);
    fetchAllIsues();
    setDetails(initialData);
    setCheckedTimeSort("");
    setStatusChecked([]);
    // setOptionChange(false);
    setSelectedOpts(
      Array.isArray(issues) ? issues.flatMap((item) => [item.status]) : null
    );
  };

  const fetchAllIssueTypes = () => {
    HelpDeskService.getHelptype()
      .then((resp) => {
        setIssueTypes(
          resp.data.map((item) => ({
            label: item.helptype,
            value: item.helptype,
          }))
        );
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    fetchAllIssueTypes();
  }, []);

  return (
    <>
      <div className="dashboard-container">
        <DashboardGreeting navHeading={navHeading} user={user} />
        <ToastContainer />
        <div className="filterBarNew mb-3">
          <div className="flex">
            <div className="heading">
              {user.role === "1" || user.role === "4" ? (
                <span>Raised issues</span>
              ) : (
                <span>Your raised issues </span>
              )}
            </div>
          </div>
          <div className="filter topbar">
            <div className="sort-filter filter">
              <div
                className="sort month-filter"
                onClick={(e) => {
                  setSortBy(true);
                }}
              >
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.636 8.68466C12.1596 7.89785 12.028 6.8463 11.3267 6.21275C10.6255 5.5792 9.56598 5.55472 8.83619 6.1552C8.10641 6.75568 7.92638 7.80003 8.41302 8.61019C8.89965 9.42035 9.90617 9.75199 10.7791 9.38978C11.1279 9.24423 11.426 8.99894 11.636 8.68466Z"
                    stroke="#4E465E"
                    stroke-width="1.6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.636 19.4113C12.1596 18.6244 12.028 17.5729 11.3267 16.9393C10.6255 16.3057 9.56598 16.2813 8.83619 16.8818C8.10641 17.4823 7.92638 18.5267 8.41302 19.3368C8.89965 20.147 9.90617 20.4785 10.7791 20.1164C11.1279 19.9708 11.426 19.7256 11.636 19.4113Z"
                    stroke="#4E465E"
                    stroke-width="1.6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M14.3624 14.0479C13.8389 13.2611 13.9705 12.2096 14.6717 11.576C15.373 10.9425 16.4325 10.918 17.1622 11.5185C17.8921 12.119 18.0721 13.1633 17.5854 13.9734C17.0988 14.7836 16.0923 15.1153 15.2194 14.753C14.8706 14.6075 14.5724 14.3622 14.3624 14.0479Z"
                    stroke="#4E465E"
                    stroke-width="1.6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.9614 6.83984C11.5306 6.83984 11.1814 7.18905 11.1814 7.61984C11.1814 8.05062 11.5306 8.39984 11.9614 8.39984V6.83984ZM20.2814 8.39984C20.7122 8.39984 21.0614 8.05062 21.0614 7.61984C21.0614 7.18905 20.7122 6.83984 20.2814 6.83984V8.39984ZM8.14149 8.39984C8.57226 8.39984 8.92149 8.05062 8.92149 7.61984C8.92149 7.18905 8.57226 6.83984 8.14149 6.83984V8.39984ZM5.72141 6.83984C5.29063 6.83984 4.94141 7.18905 4.94141 7.61984C4.94141 8.05062 5.29063 8.39984 5.72141 8.39984V6.83984ZM11.9614 17.5684C11.5306 17.5684 11.1814 17.9177 11.1814 18.3485C11.1814 18.7792 11.5306 19.1285 11.9614 19.1285V17.5684ZM20.2814 19.1285C20.7122 19.1285 21.0614 18.7792 21.0614 18.3485C21.0614 17.9177 20.7122 17.5684 20.2814 17.5684V19.1285ZM8.14149 19.1285C8.57226 19.1285 8.92149 18.7792 8.92149 18.3485C8.92149 17.9177 8.57226 17.5684 8.14149 17.5684V19.1285ZM5.72141 17.5684C5.29063 17.5684 4.94141 17.9177 4.94141 18.3485C4.94141 18.7792 5.29063 19.1285 5.72141 19.1285V17.5684ZM14.0414 13.7641C14.4722 13.7641 14.8214 13.4149 14.8214 12.9841C14.8214 12.5534 14.4722 12.2041 14.0414 12.2041V13.7641ZM5.72141 12.2041C5.29063 12.2041 4.94141 12.5534 4.94141 12.9841C4.94141 13.4149 5.29063 13.7641 5.72141 13.7641V12.2041ZM17.8613 12.2041C17.4306 12.2041 17.0813 12.5534 17.0813 12.9841C17.0813 13.4149 17.4306 13.7641 17.8613 13.7641V12.2041ZM20.2814 13.7641C20.7122 13.7641 21.0614 13.4149 21.0614 12.9841C21.0614 12.5534 20.7122 12.2041 20.2814 12.2041V13.7641ZM11.9614 8.39984H20.2814V6.83984H11.9614V8.39984ZM8.14149 6.83984H5.72141V8.39984H8.14149V6.83984ZM11.9614 19.1285H20.2814V17.5684H11.9614V19.1285ZM8.14149 17.5684H5.72141V19.1285H8.14149V17.5684ZM14.0414 12.2041H5.72141V13.7641H14.0414V12.2041ZM17.8613 13.7641H20.2814V12.2041H17.8613V13.7641Z"
                    fill="#4E465E"
                  />
                </svg>
              </div>
              <div
                className="filter"
                onClick={(e) => {
                  setFilterBy(true);
                }}
              >
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.5833 3.25H5.41667C4.22005 3.25 3.25 4.22005 3.25 5.41667V6.68587C3.25 7.26051 3.47827 7.8116 3.88461 8.21794L10.1987 14.5321C10.6051 14.9384 10.8333 15.4895 10.8333 16.0641V21.6667V21.9762C10.8333 22.6615 11.662 23.0047 12.1466 22.5201L13 21.6667L14.5321 20.1346C14.9384 19.7283 15.1667 19.1772 15.1667 18.6026V16.0641C15.1667 15.4895 15.3949 14.9384 15.8013 14.5321L22.1154 8.21794C22.5217 7.8116 22.75 7.26051 22.75 6.68587V5.41667C22.75 4.22005 21.78 3.25 20.5833 3.25Z"
                    stroke="#4E465E"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>

              <div className="filterBar">
                <div className="action">
                  {user.role === "2" || user.role === "3" ? (
                    <button
                      className="apply feedback"
                      onClick={(e) => {
                        setFeedback(true);
                      }}
                    >
                      <span>
                        <img src={AddIcon} alt="" />
                      </span>
                      <span>Raise Software Issue</span>
                    </button>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="helpDeskList">
          <div className="list">
            {Array.isArray(filter ? filteredData : issues)
              ? (filter ? filteredData : issues).map((item, index) => {
                  return (
                    <>
                      <div className="">
                        <div className="item">
                          {user.role === "1" || user.role === "4" ? (
                            <div className="flex">
                              <div className="flex1">
                                <span className="icon">
                                  <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 28 28"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M14.0012 0C10.8299 0 8.25 2.57994 8.25 5.75121C8.25 8.92248 10.8299 11.5024 14.0012 11.5024C17.1725 11.5024 19.7524 8.92248 19.7524 5.75121C19.7524 2.57994 17.1725 0 14.0012 0ZM14.0012 8.75284C12.346 8.75284 10.9996 7.40638 10.9996 5.75121C10.9996 4.09604 12.346 2.74958 14.0012 2.74958C15.6564 2.74958 17.0028 4.09604 17.0028 5.75121C17.0028 7.40638 15.6564 8.75284 14.0012 8.75284Z"
                                      fill="#988DAA"
                                    />
                                    <path
                                      d="M14.001 14.252C8.18922 14.252 3.46094 18.9802 3.46094 24.792C3.46094 25.5513 4.0765 26.1668 4.83573 26.1668H12.6262V26.6251C12.6262 27.3843 13.2418 27.9999 14.001 27.9999C14.7603 27.9999 15.3758 27.3843 15.3758 26.6251V26.1668H23.1663C23.9255 26.1668 24.5411 25.5513 24.5411 24.792C24.5411 18.9802 19.8128 14.252 14.001 14.252ZM12.6262 23.4172H6.33198C6.90346 20.2215 9.43052 17.695 12.6262 17.1236V23.4172ZM15.3758 23.4172V17.1236C18.5716 17.695 21.0986 20.2215 21.6701 23.4172H15.3758V23.4172Z"
                                      fill="#988DAA"
                                    />
                                  </svg>
                                </span>
                                <span>Employee Name:</span>
                              </div>
                              <div className="flex2">
                                <span>{item.name}</span>
                              </div>
                            </div>
                          ) : null}

                          <div className="flex">
                            <div className="flex1">
                              <span className="icon">
                                <svg
                                  width="29"
                                  height="28"
                                  viewBox="0 0 29 28"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M19 1.16602C20.9331 1.16602 22.5 2.73302 22.5 4.66602C22.5 5.31034 21.9777 5.83268 21.3333 5.83268C20.689 5.83268 20.1667 5.31034 20.1667 4.66602C20.1667 4.02169 19.6444 3.49935 19 3.49935H5C4.35567 3.49935 3.83333 4.02169 3.83333 4.66602V23.3327C3.83333 23.977 4.35567 24.4993 5 24.4993H19C19.6444 24.4993 20.1667 23.977 20.1667 23.3327V22.166C20.1667 21.5217 20.689 20.9993 21.3333 20.9993C21.9777 20.9993 22.5 21.5217 22.5 22.166V23.3327C22.5 25.2657 20.9331 26.8327 19 26.8327H5C3.06701 26.8327 1.5 25.2657 1.5 23.3327V4.66602C1.5 2.73302 3.06701 1.16602 5 1.16602H19Z"
                                    fill="#988DAA"
                                  />
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M24.5977 9.56834C24.2479 9.21854 23.6808 9.21854 23.3309 9.56834L14.2348 18.6646C14.0628 18.8365 13.9488 19.0579 13.9089 19.2978L13.717 20.4491L14.8683 20.2571C15.1082 20.2172 15.3296 20.1033 15.5014 19.9314L24.5977 10.8351C24.9476 10.4853 24.9476 9.91814 24.5977 9.56834ZM21.681 7.91843C22.9421 6.65741 24.9867 6.65739 26.2477 7.91842C27.5087 9.17946 27.5087 11.224 26.2477 12.485L17.1515 21.5813C16.6356 22.0971 15.9715 22.4388 15.2519 22.5587L14.1006 22.7507C12.5214 23.0139 11.1522 21.6448 11.4154 20.0655L11.6073 18.9142C11.7272 18.1946 12.069 17.5305 12.5848 17.0146L21.681 7.91843Z"
                                    fill="#988DAA"
                                  />
                                  <path
                                    d="M6.16406 8.16667C6.16406 7.52234 6.6864 7 7.33073 7H16.6641C17.3084 7 17.8307 7.52234 17.8307 8.16667C17.8307 8.81099 17.3084 9.33333 16.6641 9.33333H7.33073C6.6864 9.33333 6.16406 8.81099 6.16406 8.16667Z"
                                    fill="#988DAA"
                                  />
                                  <path
                                    d="M6.16406 12.8327C6.16406 12.1883 6.6864 11.666 7.33073 11.666H11.9974C12.6417 11.666 13.1641 12.1883 13.1641 12.8327C13.1641 13.477 12.6417 13.9993 11.9974 13.9993H7.33073C6.6864 13.9993 6.16406 13.477 6.16406 12.8327Z"
                                    fill="#988DAA"
                                  />
                                  <path
                                    d="M6.16406 17.5007C6.16406 16.8563 6.6864 16.334 7.33073 16.334H8.4974C9.14172 16.334 9.66406 16.8563 9.66406 17.5007C9.66406 18.145 9.14172 18.6673 8.4974 18.6673H7.33073C6.6864 18.6673 6.16406 18.145 6.16406 17.5007Z"
                                    fill="#988DAA"
                                  />
                                </svg>
                              </span>
                              <span>Issue Type:</span>
                            </div>
                            <div className="flex2">
                              <span>{item.helptype}</span>
                            </div>
                          </div>
                          <div className="flex">
                            <div className="flex1">
                              <span className="icon">
                                <svg
                                  width="29"
                                  height="28"
                                  viewBox="0 0 29 28"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M26.918 2.62275L19.9118 2.62278V0.878906C19.9118 0.395469 19.5203 0.00390625 19.0368 0.00390625C18.5534 0.00390625 18.1618 0.395469 18.1618 0.878906V2.62234H11.1618V0.878906C11.1618 0.395469 10.7703 0.00390625 10.2868 0.00390625C9.80341 0.00390625 9.41184 0.395469 9.41184 0.878906V2.62234H2.41797C1.45153 2.62234 0.667969 3.40591 0.667969 4.37234V26.2473C0.667969 27.2137 1.45153 27.9973 2.41797 27.9973H26.918C27.8844 27.9973 28.668 27.2137 28.668 26.2473V4.37234C28.668 3.40632 27.8844 2.62275 26.918 2.62275ZM26.918 26.2473H2.41797V4.37234H9.41184V5.2539C9.41184 5.73731 9.80341 6.1289 10.2868 6.1289C10.7703 6.1289 11.1618 5.73731 11.1618 5.2539V4.37278H18.1618V5.25434C18.1618 5.73778 18.5534 6.12934 19.0368 6.12934C19.5203 6.12934 19.9118 5.73778 19.9118 5.25434V4.37278H26.918V26.2473ZM20.793 13.9977H22.543C23.026 13.9977 23.418 13.6057 23.418 13.1227V11.3728C23.418 10.8898 23.026 10.4978 22.543 10.4978H20.793C20.31 10.4978 19.918 10.8898 19.918 11.3728V13.1227C19.918 13.6057 20.31 13.9977 20.793 13.9977ZM20.793 20.9973H22.543C23.026 20.9973 23.418 20.6057 23.418 20.1223V18.3723C23.418 17.8893 23.026 17.4973 22.543 17.4973H20.793C20.31 17.4973 19.918 17.8893 19.918 18.3723V20.1223C19.918 20.6062 20.31 20.9973 20.793 20.9973ZM15.543 17.4973H13.793C13.31 17.4973 12.918 17.8893 12.918 18.3723V20.1223C12.918 20.6057 13.31 20.9973 13.793 20.9973H15.543C16.026 20.9973 16.418 20.6057 16.418 20.1223V18.3723C16.418 17.8897 16.026 17.4973 15.543 17.4973ZM15.543 10.4978H13.793C13.31 10.4978 12.918 10.8898 12.918 11.3728V13.1227C12.918 13.6057 13.31 13.9977 13.793 13.9977H15.543C16.026 13.9977 16.418 13.6057 16.418 13.1227V11.3728C16.418 10.8893 16.026 10.4978 15.543 10.4978ZM8.54297 10.4978H6.79297C6.30997 10.4978 5.91797 10.8898 5.91797 11.3728V13.1227C5.91797 13.6057 6.30997 13.9977 6.79297 13.9977H8.54297C9.02597 13.9977 9.41797 13.6057 9.41797 13.1227V11.3728C9.41797 10.8893 9.02597 10.4978 8.54297 10.4978ZM8.54297 17.4973H6.79297C6.30997 17.4973 5.91797 17.8893 5.91797 18.3723V20.1223C5.91797 20.6057 6.30997 20.9973 6.79297 20.9973H8.54297C9.02597 20.9973 9.41797 20.6057 9.41797 20.1223V18.3723C9.41797 17.8897 9.02597 17.4973 8.54297 17.4973Z"
                                    fill="#988DAA"
                                  />
                                </svg>
                              </span>
                              <span>Date:</span>
                            </div>
                            <div className="flex2">
                              <span>
                                {moment(
                                  item.issuedate,
                                  "DD-MM-YYYY HH:mm:ss"
                                ).format("Do MMMM YYYY")}
                              </span>
                            </div>
                          </div>
                          <div className="flex">
                            <div className="flex1">
                              <span className="icon">
                                <svg
                                  width="28"
                                  height="28"
                                  viewBox="0 0 28 28"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M2.85938 17.4648C4.10771 21.4782 7.46772 24.5698 11.6444 25.4215"
                                    stroke="#988DAA"
                                    stroke-width="2.75"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M2.39062 12.8107C2.98562 6.91898 7.95561 2.33398 13.999 2.33398C20.0423 2.33398 25.0123 6.93065 25.6073 12.8107"
                                    stroke="#988DAA"
                                    stroke-width="2.75"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M16.3438 25.4334C20.5087 24.5818 23.8571 21.5251 25.1288 17.5234"
                                    stroke="#988DAA"
                                    stroke-width="2.75"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              </span>
                              <span>Status</span>
                            </div>
                            <div>
                              {user.role === "1" || user.role === "4" ? (
                                <Select
                                  styles={{
                                    control: (
                                      baseStyles,
                                      { isFocused, selectProps, isHovered }
                                    ) => {
                                      const optionValue = Array.isArray(
                                        statusOpts
                                      )
                                        ? statusOpts.filter(
                                            (option) =>
                                              selectedOpts[index] ===
                                              option.value
                                          )
                                        : [];

                                      return {
                                        ...baseStyles,
                                        height: "45px",
                                        fontSize: "16px",
                                        lineHeight: "20px",
                                        fontWeight: "500",
                                        border: isHovered
                                          ? "none"
                                          : isFocused
                                          ? "none"
                                          : "none",
                                        outline: isHovered
                                          ? "none"
                                          : isFocused
                                          ? "none"
                                          : "none",
                                        boxShadow: "none",
                                        borderRadius: "25px",
                                        backgroundColor: optionValue[0].color,
                                      };
                                    },
                                    option: (
                                      baseStyles,
                                      { isFocused, isSelected }
                                    ) => ({
                                      ...baseStyles,
                                      fontSize: "16px",
                                      lineHeight: "20px",
                                      fontWeight: "500",
                                      borderRadius: "4px",
                                      backgroundColor: isSelected
                                        ? "rgba(177, 206, 251, 1)"
                                        : isFocused
                                        ? "rgba(177, 206, 251, 1)"
                                        : "rgba(255, 255, 255, 1)",
                                      color: isSelected
                                        ? "rgba(78, 70, 94, 1)"
                                        : isFocused
                                        ? "rgba(78, 70, 94, 1)"
                                        : "rgba(78, 70, 94, 1)",
                                    }),
                                    menu: (baseStyles, state) => ({
                                      ...baseStyles,
                                      backgroundColor: "rgba(255, 255, 255, 1)",
                                      boxShadow:
                                        "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                                    }),
                                    menuPortal: (baseStyles) => ({
                                      ...baseStyles,
                                      zIndex: 9999, // Ensure the portal has a very high zIndex
                                    }),
                                  }}
                                  options={statusOpts}
                                  menuPortalTarget={document.body}
                                  onChange={(e) => {
                                    handleSelectChange(e, index, item.id);
                                  }}
                                  value={
                                    Array.isArray(statusOpts)
                                      ? statusOpts.filter(
                                          (option) =>
                                            selectedOpts[index] === option.value
                                        )
                                      : []
                                  }
                                />
                              ) : (
                                <>
                                  <div
                                    className={
                                      item.status === "1"
                                        ? "status new"
                                        : item.status === "2"
                                        ? "status inprocess"
                                        : "status resolved"
                                    }
                                  >
                                    <span>
                                      {" "}
                                      {item.status === "1"
                                        ? "New"
                                        : item.status === "2"
                                        ? "In-Process"
                                        : "Resolved"}
                                    </span>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                          <div className="actions">
                            <button>
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                onClick={(e) => {
                                  setShowIssue(true);
                                  setIssueData(item);
                                }}
                              >
                                <path
                                  d="M15 12C15 13.6569 13.6569 15 12 15C10.3432 15 9 13.6569 9 12C9 10.3431 10.3432 9 12 9C13.6569 9 15 10.3431 15 12Z"
                                  stroke="#0F123F"
                                  stroke-width="1.8"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M12.0012 5C7.52354 5 3.73326 7.94288 2.45898 12C3.73324 16.0571 7.52354 19 12.0012 19C16.4788 19 20.2691 16.0571 21.5434 12C20.2691 7.94291 16.4788 5 12.0012 5Z"
                                  stroke="#0F123F"
                                  stroke-width="1.8"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </button>
                            {user.role === "2" || user.role === "3" ? (
                              <>
                                {" "}
                                <button>
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    onClick={(e) => {
                                      setEditFeedback(true);
                                      setIssueData(item);
                                    }}
                                  >
                                    <path
                                      d="M16.7925 6.61653L6.90079 16.5082C6.01746 17.3999 3.37578 17.8081 2.77578 17.2165C2.17578 16.6248 2.60079 13.9832 3.48413 13.0916L13.3758 3.19989C13.8326 2.7649 14.4412 2.5257 15.0719 2.53338C15.7026 2.54107 16.3053 2.79504 16.7513 3.24104C17.1973 3.68703 17.4512 4.28973 17.459 4.92042C17.4666 5.55111 17.2275 6.1598 16.7925 6.61653Z"
                                      stroke="#0F123F"
                                      stroke-width="1.8"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </button>
                                <button>
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    onClick={(e) => {
                                      setDeleteIssue(true);
                                      setIssueData(item);
                                    }}
                                  >
                                    <path
                                      d="M4 7H20"
                                      stroke="#0F123F"
                                      stroke-width="1.8"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M6 10L7.70141 19.3578C7.87432 20.3088 8.70258 21 9.66915 21H14.3308C15.2974 21 16.1257 20.3087 16.2986 19.3578L18 10"
                                      stroke="#0F123F"
                                      stroke-width="1.8"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
                                      stroke="#0F123F"
                                      stroke-width="1.8"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </button>
                              </>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })
              : null}
          </div>
        </div>

        <div
          className={`${holiday ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setHoliday(false);
          }}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          ></div>
        </div>

        <div
          className={`${feedback ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setFeedback(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <AddFeedback
              fetchAllIsues={fetchAllIsues}
              issueTypes={issueTypes}
            />
          </div>
        </div>

        <div
          className={`${showIssue ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setShowIssue(false);
          }}
        >
          <div className="" onClick={(e) => e.stopPropagation()}>
            <div
              className={`${
                showIssue ? "sortByModal  visible" : "sortByModal  hidden"
              }`}
            >
              <div className="heading">
                <span>Issue Description</span>
              </div>
              {issueData.description}
            </div>
          </div>
        </div>

        <div
          className={`${editFeedback ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setEditFeedback(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <EditFeedback
              editFeedback={editFeedback}
              setEditFeedback={setEditFeedback}
              issueData={issueData}
              fetchAllIsues={fetchAllIsues}
              issueTypes={issueTypes}
            />
          </div>
        </div>

        <div
          className={`${deleteIssue ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setDeleteIssue(false);
          }}
        >
          <div className="" onClick={(e) => e.stopPropagation()}>
            <Delete
              heading="Delete Issue"
              para="Are you sure you want to delete this issue?"
              showDelete={deleteIssue}
              setShowDelete={setDeleteIssue}
              remove={removeIssue}
            />
          </div>
        </div>

        <div
          className={`${sortBy ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setSortBy(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <GrievencesSortModal
              checkedTimeSort={checkedTimeSort}
              setCheckedTimeSort={setCheckedTimeSort}
              status={status}
              setStatus={setStatus}
              applySort={applySort}
              resetFilter={resetFilter}
              validated={validated}
              statusChecked={statusChecked}
              setStatusChecked={setStatusChecked}
            />
          </div>
        </div>

        <div
          className={`${filterBy ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setFilterBy(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <GrievancesFilterModal
              status={status}
              setStatus={setStatus}
              applyFilter={applyFilter}
              resetFilter={resetFilter}
              validated={validated}
              details={details}
              setDetails={setDetails}
              issueTypes={issueTypes}
            />
          </div>
        </div>

        <Modal
          className="alert-modal"
          show={shwoAlert}
          onHide={handleCloseAlert}
        >
          <Modal.Header closeButton>
            <Modal.Title>Change Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to change the status</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseAlert}>
              Close
            </Button>
            <Button variant="primary" onClick={handleUpdateStatus}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default HelpDesk;
